module.exports = __webpack_public_path__ + "img/user.9765068e.svg";